"use strict";
const timeout = (defaultTimeout) => (ctx, next) => {
  const { timeout: timeoutCount = defaultTimeout } = ctx.req;
  if (timeoutCount > 0) {
    return Promise.race([
      new Promise(
        (resolve, reject) => setTimeout(reject, timeoutCount, "Request Timeout")
      ),
      next()
    ]);
  }
  return next();
};
export default timeout;
//# sourceMappingURL=timeout.js.map
